import { useMemo, useState } from "react";

import { useIntl } from "react-intl";

import { useSearchParameters } from "@/components/signup/hooks/use-search-parameters";
import { DataFoundationsWrapper } from "@/utils/data-foundations/data-foundation-types";

import { useScreenManager } from "../../hooks/use-screen-manager";
import { getPrimaryProduct } from "../../hooks/utils/use-cloud-status-utils";
import { UserSegmentationTeamType } from "../../models/user-segmentation";
import {
    isEligibleTeamTypeToViewJtbdScreen,
    useGetTeamTypeData
} from "../../utils/utils";
import { JiraOnboardingContainer } from "../jira/jira-onboarding-container/jira-onboarding-container";

import Buttons from "./components/buttons";
import CheckboxGrid from "./components/checkbox-grid";
import { checkboxValues } from "./constants";
import { messages } from "./messages";

const JtbdView = () => {
    const { skipScreen } = useScreenManager();
    const intl = useIntl();

    const { teamType, teamTypeCheckboxes, isSoftwareTeamType } =
        useGetTeamTypeData();

    const [checkboxes, setCheckboxes] = useState(teamTypeCheckboxes);

    const handleCheckboxChange = (checkboxes: checkboxValues[]) => {
        setCheckboxes(checkboxes);
    };

    const { products, edition } = useSearchParameters();
    const productKey = getPrimaryProduct(products);
    const dataFoundationAttributes = {
        productKey,
        edition,
        teamType
    };

    const shouldSkipJtbdScreen = useMemo(
        () =>
            !isEligibleTeamTypeToViewJtbdScreen(
                teamType as UserSegmentationTeamType
            ),
        [teamType]
    );

    if (
        checkboxes === undefined ||
        teamType === undefined ||
        shouldSkipJtbdScreen
    ) {
        skipScreen();
        return;
    }

    const countTrue = () => {
        let count = 0;
        checkboxes.forEach((checkbox) => {
            if (checkbox.isChecked) {
                count++;
            }
        });
        return count;
    };

    const numSelected = countTrue();

    const view = (
        <JiraOnboardingContainer
            header={intl.formatMessage({
                id: messages.header.id,
                defaultMessage: messages.header.defaultMessage
            })}
            subheader={intl.formatMessage({
                id: messages.subHeader.id,
                defaultMessage: messages.subHeader.defaultMessage
            })}
            hideSubHeader={isSoftwareTeamType}
            hideFooterOnMobile={true}
        >
            <CheckboxGrid
                checkboxes={checkboxes}
                handleCheckboxChange={handleCheckboxChange}
                // errorState={errorState}
                // handleErrorChange={handleErrorChange}
                numSelected={numSelected}
                header={intl.formatMessage({
                    id: messages.chooseOptions.id,
                    defaultMessage: messages.chooseOptions.defaultMessage
                })}
                disableSelectionLimit={isSoftwareTeamType}
            />
            <Buttons
                checkboxes={checkboxes}
                teamType={teamType}
                // handleErrorChange={handleErrorChange}
            />
        </JiraOnboardingContainer>
    );

    return (
        <DataFoundationsWrapper
            dataFoundationsEventOption="JTBDScreenViewed"
            attributes={dataFoundationAttributes}
        >
            {view}
        </DataFoundationsWrapper>
    );
};

export default JtbdView;
